const PRIMARY_BUTTONS_COUNT = 2;
const BACKGROUND = 'Background';
const TEXT = 'Text';
const BORDER = 'Border';

const getPrimaryButtonsAdvancedColorsKeys = (colorKey) =>
  [...Array(PRIMARY_BUTTONS_COUNT)].map((_, number) => {
    let name;

    switch (true) {
      case colorKey.includes(BACKGROUND):
        name = BACKGROUND;
        break;
      case colorKey.includes(BORDER):
        name = BORDER;
        break;
      default:
        name = TEXT;
    }

    const regex = new RegExp(`(\\d+)(?=${name})`);
    return colorKey.replace(regex, number + 1);
  });

export default getPrimaryButtonsAdvancedColorsKeys;
